import _ from 'underscore';
import { PATH_SPLITER } from '../../constant';

export class ProductGroupPathUtil {
  constructor({ deps }) {
    this.i18n = deps.i18n;
  }

  isEverythingElse = condition => condition.Operand && !condition.Attribute;

  isAllProduct = condition => !condition.Operand && !condition.Attribute;

  getNearestParentCondition = ParentConditions => (ParentConditions[ParentConditions.length - 1]);

  getDisplayName = (condition, parentConditions) => {
    if (this.isAllProduct(condition)) {
      return this.i18n.getString('ShoppingCampaign_AllProducts');
    }
    const parentCondition = this.getNearestParentCondition(parentConditions);
    if (this.isEverythingElse(condition)) {
      if (this.isEverythingElse(parentCondition)) {
        return this.i18n.getString('ProductGroupsGrid_EverythingElse');
      }
      return this.i18n.getString('ProductGroupsGrid_EverythingElseIn').replace('{0}', this.getDisplayName(parentCondition, _.initial(parentConditions)));
    }
    return condition.Attribute;
  }

  getPath = (parentConditions) => {
    if (!parentConditions || _.isEmpty(parentConditions)) {
      return '';
    }
    let path = '';
    path += this.getDisplayName(_.first(parentConditions), []);
    for (let i = 1; i < parentConditions.length; i += 1) {
      path += ` ${PATH_SPLITER} ${this.getDisplayName(parentConditions[i], _.initial(parentConditions, parentConditions.length - i))}`;
    }
    return path;
  }

  getFullPath = (conditions) => {
    const path = [];
    for (let i = 0; i < conditions.length; i += 1) {
      path.push(_.defaults({
        Attribute: this.getDisplayName(conditions[i], _.initial(conditions, conditions.length - i)),
      }, conditions[i]));
    }
    return path;
  }
}
